module.exports = __webpack_public_path__ + "static/img/fangdichan.f51c3231.png";